import styled, { css } from 'styled-components';
import { Heading3Styles } from '../typography';
import { getColor, getColorShade, getElevation, getSizeBy, getThemeProp, getBorderThickness, getWidgetShadowOptions } from '../../../src/styled/utils';
import { BorderBottom } from '../../../src/styled/shared-styles';
import { animated } from '@react-spring/web';
export const ActionField = styled.div `
  position: absolute;
  top: ${getSizeBy(3)};
  right: ${getSizeBy(3)};
`;
export const CardCSS = css `
  overflow: hidden;
  background-color: ${getColor('surface')};
  border: ${getBorderThickness()} solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('widgetsBorderRadius')}px;
`;
export const StyledCard = styled.div `
  ${CardCSS}
  position: relative;
  height: 100%;
  box-shadow: ${({ $shadowEnabled = true, $elevation = 0, theme }) => $shadowEnabled ? getWidgetShadowOptions({ theme }) : getElevation($elevation)};
`;
export const StyledCardHeader = styled(animated.header) `
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${getSizeBy(3.5)} ${getSizeBy(4)};
  ${BorderBottom}
`;
export const StyledCardHeaderTypography = styled(animated.h6) `
  ${Heading3Styles}
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
export const StyledCardContent = styled(animated.div) `
  width: 100%;
  padding: ${getSizeBy(3)} ${getSizeBy(4)};
`;
